module.exports = __webpack_public_path__ + "img/medical-conditions.3d6c1702.svg";